<h1 class="mc-tt">Mis mascotas</h1>
<p class="mx-sub">Cuanto más sepamos de ellas, mejor te podemos avisar lo que les toca.</p>

<div class="mc-blk">
  <div class="mx-pets">

    <app-pet-card *ngFor="let pet of activas; let i = index"
                  [pet]="pet"
                  [indice]="i"
                  [proximaVacuna]="vacunaDe(pet)"
                  textoAccion="Ver su ficha">
    </app-pet-card>

    <a class="mx-new" [routerLink]="['/add-pet']">
      <span class="mx-plus">+</span>
      Agregar una mascota
    </a>

  </div>
</div>

<!-- Las que fallecieron: fuera del listado de activas, pero no escondidas.
     Sin etiqueta, sin borde de tarjeta y con la foto apagada. El titulo habla
     de la relacion, no del hecho. Es la nota 1 del brief. -->
<div class="mx-memblk" *ngIf="hayAcompanaron">

  <h2>Los que te acompañaron</h2>

  <a class="mx-memrow" *ngFor="let pet of acompanaron" [routerLink]="['/pet', pet.id]">
    <span class="mx-memfoto">
      <img *ngIf="pet.pictureUrl" [src]="pet.pictureUrl" [alt]="pet.name">
      <ng-container *ngIf="!pet.pictureUrl">{{ inicial(pet) }}</ng-container>
    </span>
    <span class="mx-memtx">
      <b>{{ pet.name }}</b>
      <em *ngIf="descripcion(pet)">{{ descripcion(pet) }}</em>
    </span>
    <span class="mx-cv">›</span>
  </a>

</div>

<loading-indicator *ngIf="isLoading"></loading-indicator>
